export default function Marketplace() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold">Marketplace</h1>
      <div className="bg-white p-8 rounded-lg shadow text-center">
        <p className="text-gray-600">Marketplace coming soon!</p>
        <p className="text-sm text-gray-500 mt-2">Browse and discover apps built on the Dentulu platform.</p>
      </div>
    </div>
  );
}